import { render } from "./AdministrationOverviewView.vue?vue&type=template&id=5bc1dc65&scoped=true"
import script from "./AdministrationOverviewView.vue?vue&type=script&lang=js"
export * from "./AdministrationOverviewView.vue?vue&type=script&lang=js"

import "./AdministrationOverviewView.vue?vue&type=style&index=0&id=5bc1dc65&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc1dc65"]])

export default __exports__